import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { LabelManagementConfig } from './advanced-typeahead.constants';
import { checkInputsForText } from '../../design-system.helper';

const defaultMaxOptionLength = 50;

@Component({
  selector: 'zipari-advanced-typeahead',
  styleUrls: ['./advanced-typeahead.component.scss'],
  templateUrl: './advanced-typeahead.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdvancedTypeaheadComponent implements OnInit {
  @Input() config: LabelManagementConfig;
  @Input() options: string[] = [];
  @Input() loading = false;
  @Input() maxOptionLength = defaultMaxOptionLength;
  @Input() showDropdown: boolean;
  @Output() valueChange = new EventEmitter<string>();
  @Output() selected = new EventEmitter<string>();

  filteredOptions: string[] = [];
  searchInput: UntypedFormControl = new UntypedFormControl();
  newOptionIsTooLong = false;

  ngOnInit(): void {
    const [config, options, loading, maxOptionLength, showDropdown] =
      checkInputsForText([
        this.config,
        this.options,
        this.loading,
        this.maxOptionLength,
        this.showDropdown,
      ]);

    this.config = config as LabelManagementConfig;
    this.options = options as string[];
    this.loading = loading as boolean;
    this.maxOptionLength = maxOptionLength as number;
    this.showDropdown = showDropdown as boolean;

    this.filteredOptions = this.options.slice(0, 10);

    this.searchInput.valueChanges.subscribe((value) => {
      this.handleValueChanges(value);
    });
  }

  handleValueChanges(formValues: string) {
    if (formValues) {
      this.showDropdown = true;

      if (formValues.length > 2) {
        this.filteredOptions = this.options
          .filter((option) =>
            option.toLowerCase().includes(formValues.toLowerCase()),
          )
          .slice(0, 10);
      } else {
        this.filteredOptions = this.options.slice(0, 10);
      }
    } else {
      this.filteredOptions = this.options.slice(0, 10);
    }

    if (formValues?.length > this.maxOptionLength) {
      this.newOptionIsTooLong = true;

      return;
    }

    this.newOptionIsTooLong = false;
    this.valueChange.emit(formValues);
  }

  onIconClick(): void {
    if (this.showDropdown) {
      this.showDropdown = false;
      this.searchInput.value && this.searchInput.reset();
    } else {
      this.valueChange.emit(null);
      this.showDropdown = true;
    }
  }

  onOptionClick(option: string): void {
    if (option?.length > this.maxOptionLength) return;
    this.searchInput.setValue(option, { emitEvent: false });
    this.selected.emit(option);
    this.showDropdown = false;
  }
}
